import React, {useMemo} from 'react'
import {useRouteMatch} from "react-router-dom";
import { useTranslation } from "@/langs/useTranslation";
import RawBreadCrumbs from "@/components/BreadCrumbs";
import {Box, Typography} from "@material-ui/core";
import TemplateFrom from "./WindowsTemplateForm";


const TemplateList = () => {
  const { t, userLanguage } = useTranslation();
  const editMode = useRouteMatch({
    path: "/profile-config/edit-template-windows/:id"
  });
  const readOnly = useRouteMatch({
    path: "/profile-config/template-windows/:id"
  });
  const isHistory = useRouteMatch({
    path: "/profile-config/install-history-windows/:id"
  })

  const BreadCrumbs = useMemo(() => RawBreadCrumbs(isHistory?
    [
      {name: t({defaultMessage: "安装历史"}), to: '/profile-config/install-history'}
    ] :
    [
      {name: t({defaultMessage: "配置文件"}), to: '/profile-config/template'}
  ]), [])

  const pageName = useMemo(() => {
    if (editMode) return t({ defaultMessage: "编辑配置模板" })
    if (readOnly) return t({ defaultMessage: "查看配置模板" })
    if (isHistory) return t({ defaultMessage: "查看配置文件" })
    return t({ defaultMessage: "新建配置模板" })
  }, [userLanguage, editMode, readOnly, isHistory])

  return (
    <>
      <BreadCrumbs pageName={pageName} />
      <Box display="flex" flex={1} flexDirection="column">
        { !isHistory && (
          <Box display="flex" alignItems="center">
            <Typography variant="h4" style={{marginBottom: 24}}>
              {pageName}
            </Typography>
            <Typography variant="subtitle1" style={{marginBottom: 24}}>
              {t({defaultMessage: "(暂不支持windows7)"})}
            </Typography>
          </Box>
        )}
        <TemplateFrom isHistory={!!isHistory} readOnly={!!readOnly || !!isHistory} id={editMode?.params?.id || readOnly?.params?.id || isHistory?.params?.id} />
      </Box>
    </>
  );
};

export default TemplateList;